import { StorageEnum } from "@/types/enum";
import { getItem } from "@/utils/storage";
import { useCallback, useEffect } from "react";
import { useRouter } from "../hooks";

type Props = {
	children: React.ReactNode;
};
export default function LoginAuthGuard({ children }: Props) {
	const router = useRouter();
	const userToken = getItem(StorageEnum.UserToken);

	const check = useCallback(() => {
		if (!userToken) {
			router.replace("/login");
		}
	}, [router, userToken]);

	useEffect(() => {
		check();
	}, [check]);

	return <>{children}</>;
}
